// There are two implementations of drag managers
// 1. a sessionStorage backed storage manager
// 2. one backed only in memory.  this is only used for testing.

const _parse = (data: string) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return {};
  }
};

const load = (namespace: string): CMxCommonApp.DragManager => {
  return {
    clear: () => {
      sessionStorage.removeItem(namespace);
    },
    parseEvent: (ev: any) => {
      const data = ev.dataTransfer.getData('text');
      return _parse(data);
    },
    get: (key?: string) => {
      const data = _parse(sessionStorage.getItem(namespace));
      return key ? data[key] : data;
    },
    set: (data: any, key: string) => {
      if (!key) {
        sessionStorage.setItem(namespace, JSON.stringify({ ...data }));
      } else {
        // implement keys
        const retrieved = _parse(sessionStorage.getItem(namespace)) || {};
        retrieved[key] = retrieved[key] || {};
        retrieved[key] = data;
        sessionStorage.setItem(namespace, JSON.stringify({ ...retrieved }));
      }
    }
  };
};

// dragOver events do NOT give access to the getData from the
// dataTransfer object.  Instead, we keep a simple object that
// points to the data in the event being dragged.
// The reason that this is an object is so that we can call
// delete on it's property on drag end.

const DRAG_DATA = {};

const getDraggedObject = () => {
  const keys = Object.keys(DRAG_DATA);
  if (keys.length === 0) return {};
  return DRAG_DATA[keys[0]];
};

// just used for testing presently.
const loadMemory = (namespace: string): CMxCommonApp.DragManager => {
  DRAG_DATA[namespace] = DRAG_DATA[namespace] || {};

  return {
    clear: () => {
      delete DRAG_DATA[namespace];
    },
    parseEvent: (ev: any) => {
      const data = ev.dataTransfer.getData('text');
      return _parse(data);
    },
    get: optKey => {
      const data = getDraggedObject();
      return optKey ? data[optKey] : data;
    },
    set: (data: any, optKey: string) => {
      if (!optKey) {
        DRAG_DATA[namespace] = data;
      } else {
        DRAG_DATA[namespace][optKey] = DRAG_DATA[namespace][optKey] || {};
        DRAG_DATA[namespace][optKey] = data;
      }
    }
  };
};

export { load, loadMemory };
